import {
  ADD_OFFER_SUCCESS,
  CLEAR_ATTACHED_FILES_SUCCESS,
  DELETE_FILE_ERROR,
  DELETE_FILE_SUCCESS,
  DELETE_FILE,
  DISABLED_INPUT,
  GET_ATTACHED_FILES_SELLER_ERROR,
  GET_ATTACHED_FILES_SELLER_SUCCESS,
  GET_ATTACHED_FILES_SELLER,
  GET_DOWNLOAD_FILE_ERROR,
  GET_DOWNLOAD_FILE_SUCCESS,
  GET_DOWNLOAD_FILE,
  GET_TAXATION_ERROR,
  GET_TAXATION_SUCCESS,
  GET_TAXATION,
  HIDE_ERRORS_QUOTE_BID_SELLER_SUCCESS,
  SAVE_QUOTE_SELLER_SUCCESS,
  SHOW_ERROR_AMOUNT_SUCCESS,
  UPLOAD_FILE_SELLER_ERROR,
  UPLOAD_FILE_SELLER_SUCCESS,
  UPLOAD_FILE_SELLER
} from './QuoteBidSeller.actions'

const quoteProductsState = {
  addOffer: false,
  attachedFiles: [],
  disabled: false,
  error: false,
  errors: [],
  loading: false,
  quoteBidSeller: {},
  taxationOptions: []
}

/**
 * The Quote Bid's reducer.
 */
const quoteBidReducer = (state = quoteProductsState, { payload, type }) => {
  switch (type) {
    case GET_TAXATION:
    case GET_ATTACHED_FILES_SELLER:
    case UPLOAD_FILE_SELLER:
    case GET_DOWNLOAD_FILE:
    case DELETE_FILE: {
      return { ...state, loading: true }
    }
    case GET_TAXATION_ERROR:
    case GET_ATTACHED_FILES_SELLER_ERROR:
    case UPLOAD_FILE_SELLER_ERROR:
    case GET_DOWNLOAD_FILE_ERROR:
    case DELETE_FILE_ERROR: {
      return { ...state, loading: false, error: true, errors: payload.error }
    }
    case UPLOAD_FILE_SELLER_SUCCESS:
    case GET_DOWNLOAD_FILE_SUCCESS:
    case DELETE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false
      }
    }
    case GET_TAXATION_SUCCESS: {
      return {
        ...state,
        taxationOptions: payload.taxation,
        loading: false
      }
    }
    case SAVE_QUOTE_SELLER_SUCCESS: {
      return {
        ...state,
        quoteBidSeller: payload.quoteBidSeller,
        errors: []
      }
    }
    case GET_ATTACHED_FILES_SELLER_SUCCESS: {
      return {
        ...state,
        attachedFiles: payload.attachedFiles,
        loading: false
      }
    }
    case HIDE_ERRORS_QUOTE_BID_SELLER_SUCCESS: {
      return {
        ...state,
        errors: [],
        error: false
      }
    }
    case SHOW_ERROR_AMOUNT_SUCCESS: {
      return {
        ...state,
        errors: [
          {
            code: '400-1',
            description: 'compraagil_message_error_cotizacion_montoTotal'
          }
        ]
      }
    }
    case ADD_OFFER_SUCCESS: {
      return { ...state, addOffer: payload.addOffer }
    }
    case CLEAR_ATTACHED_FILES_SUCCESS: {
      return { ...state, attachedFiles: [] }
    }
    case DISABLED_INPUT: {
      return { ...state, disabled: true }
    }

    default:
      return state
  }
}

export default quoteBidReducer
